import React, { useEffect, useState } from "react";
import Table from 'react-bootstrap/Table';
import { FaRegCheckCircle } from 'react-icons/fa';
import { API } from 'aws-amplify';
import moment from 'moment';
import Pagination from  '../../components/Pagination/Pagination';
import Spinner from 'react-bootstrap/Spinner';


const DetZone = (props) => {

    const {
        // assetName,
        isLoadingCounts,
        asset,
        dateSel,
        // dateSelTo,
        timeFrom,
        timeTo,
        params,
        addToast,
        RLDstat,
        setRLDstat,
        RLDdet,
        setRLDdet,
     } = props

    // const [RLDstat, setRLDstat] = useState([]);
    // const [RLDdet, setRLDdet] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingStat, setIsLoadingStat] = useState(false);


     const vclass = [["1","PEDESTRIAN"], ["2", "BIKE"], ["3","MOTORBIKE"], ["4","CAR"], ["6","VAN"], ["7","SHORT TRUCK"] , ["8","LONG TRUCK"], ["0","UNDEFINED"]]

    // UndefinedOct = 0
    // PedestrianOct = 1
    // BicycleOct = 2
    // MotorbikeOct -3
    // CarOct = 4
    // ReservedOct = 5
    // DeliveryOct = 6
    // ShortTruckOct = 7
    // LongTruckOct = 8

     // remove consecutives items
    const removeDuplicates = (arr) =>  arr.filter((item, pos, arr) => {
        // Always keep the 0th element as there is nothing before it
        // Then check if each element is different than the one before it
        return pos === 0 || item.object_id !== arr[pos-1].object_id;
    });

    //  SPEED DETECTION START
    // --------------------------
    useEffect(() => {
        
        // Total vehicles classification
        const fetchRLDStats = async () => {
            setIsLoadingStat(true);
            const dtF = new Date(dateSel)
            const dtT = new Date(dateSel)
    
            const dtFrom = moment.utc(dtF).local().format('YYYY-MM-DD')
            const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');
            let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();
    
            const dtTo = moment.utc(dtT).local().format('YYYY-MM-DD')
            const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');
            let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();
    
    
            if (dateEnd >= dateStart){
                const filter = asset +'?start='+ dateStart +'&end='+ dateEnd
    
                let data = []
                await API.get('red_light','/'+ filter, params)
                .then(resp => {
                    data = resp.length>0 && resp[0].entries
                    // console.log(data)
                    const rldstat = []
                    for (let i = 0; i < data.length; i++){
                        if (data[i].RED_LIGHTS_VEHICLES >0)
                            rldstat.push({
                                time: data[i].ACTIVITY_ON,
                                dilemma_veh: data[i].DILEMMA_VEHICLES,
                                max_speed: data[i].MAX_SPEED,
                                max_speed_dilemma: data[i].MAX_SPEED_DILEMMA,
                                red_light_veh: data[i].RED_LIGHTS_VEHICLES,
                                total_speed_dilemma: data[i].TOTAL_SPEED_DILEMMA
                            })
                    }

                    setRLDstat(rldstat)
                }).catch(error => {
                    console.log(error)
                    addToast('Error Loading Data', { appearance: 'error' });
                });
            }
            setIsLoadingStat(false);
        }

        // Total vehicles classification
        const fetchRLDDetail = async () => {
            setIsLoading(true);
            const dtF = new Date(dateSel)
            const dtT = new Date(dateSel)
    
            const dtFrom = moment.utc(dtF).local().format('YYYY-MM-DD')
            const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');
            let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();
    
            const dtTo = moment.utc(dtT).local().format('YYYY-MM-DD')
            const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');
            let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();
    
    
            if (dateEnd >= dateStart){
                const filter = asset +'?start='+ dateStart +'&end='+ dateEnd
                
                let data = []
                await API.get('red_light_det','/'+ filter, params)
                .then(resp => {
                    data = resp
                    let rlddet = []
                    for (let j = 0; j < data.length; j++){
                        const arr = data[j] && data[j].entries
                        // console.log(arr)
                        
                        for (let i = 0; i < arr.length; i++){
                            const x = arr[i]
                            if (x.SPEED >=30 && x.DISTANCE <=26.4)
                                rlddet.push({
                                    time:  moment.utc(x.CONSTRUCT_TIME).local().format('HH:mm'),
                                    time_ss:  moment.utc(x.CONSTRUCT_TIME).local().format('HH:mm:ss'),
                                    object_id: x.OBJECT_ID,
                                    // class: x.CLASS,
                                    class: vclass.find(i => i[0] === x.CLASS) && (vclass.find(i => i[0] === x.CLASS)[1] || ''), //vclass[x.CLASS],
                                    distance: x.DISTANCE,
                                    speed: x.SPEED,
                                    zone: x.ZONE
                                })
                        }
                    }
                    rlddet = rlddet.sort((a, b)=> a.object_id < b.object_id ? -1 : 1).sort((a, b)=> a.time < b.time ? -1 : 1)

                    rlddet = removeDuplicates(rlddet)
                    // console.log(rlddet)
                    setRLDdet(rlddet)
                }).catch(error => {
                    console.log(error)
                    addToast('Error Loading Data', { appearance: 'error' });
                });
            }
            paginate(1);
            setIsLoading(false);
        }

        if (isLoadingCounts){
            setRLDstat([]);
            setRLDdet([]);
            fetchRLDStats();
            fetchRLDDetail();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isLoadingCounts ]);
    // SPEED DETECTION END

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItemList = RLDdet.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = pageNumber => setCurrentPage(pageNumber);
  

return (
    <div className="col-md-12 p-2">
        <h2 className="text-header">Detection Zone</h2>
        <div className="text-description small pb-3">
        time of vehicle red-light violations
        </div>
        {(!isLoadingStat) ? (
        <div className="row">
            <div className="col-md-12">
            <Table responsive hover className="small p-0 border">
            <thead>
                <tr>
                <th className="table-th-det">Time</th>
                <th className="table-th-det">Dilemma Vehicle</th>
                <th className="table-th-det">Red Light Veh</th>
                <th className="table-th-det">Max Speed</th>
                <th className="table-th-det">Max Speed Dilemma</th>
                {/* <th className="table-th-det">Total Speed Dilemma</th> */}
                </tr>
            </thead>
            <tbody>
            {RLDstat.map((x, i) =>
            <tr key={"rld"+i} className="table-tr">
                <td className="table-td-det">{x.time}</td>
                <td className="table-td">{x.dilemma_veh}</td>
                <td className="table-td">{x.red_light_veh}</td>
                <td className="table-td">{parseFloat(x.max_speed).toFixed(2)}</td>
                <td className="table-td">{parseFloat(x.max_speed_dilemma).toFixed(2)}</td>
                {/* <td className="table-td">{parseFloat(x.total_speed_dilemma).toFixed(2)}</td> */}
            </tr>
            )}
            </tbody>
            </Table>
            </div>
        </div>
        ):(
            <div className="col-md-12 hide-from-printer">
            <Spinner animation="grow" size="sm" role="status" variant="warning" />
            <span className="text-dark">  Loading...</span>
            </div>
            )}

        <h2 className="text-header">Detection Zone Details</h2>
        <div className="text-description small pb-3 ">
        speed of each vehicle entering detection zone
        <br/><FaRegCheckCircle/> RED LIGHT: ON
        <br/><FaRegCheckCircle/> DISTANCE less than 26.4 meter from the stopbar
        <br/><FaRegCheckCircle/> SPEED threshold 30 Km/h
        </div>
        {(!isLoading) ? (
        <div className="row">
            <div className="col-md-12">
            <Table responsive hover className="small p-0 border">
            <thead>
                <tr>
                <th className="table-th-det">Time</th>
                {/* <th className="table-th-det">Object ID</th> */}
                <th className="table-th-det">Class</th>
                <th className="table-th-det">Distance</th>
                <th className="table-th-det">Speed</th>
                {/* <th className="table-th-det">Zone</th> */}
                </tr>
            </thead>
            <tbody>
            {currentItemList.map((x, i) =>
            <tr key={"rlddet"+i} className="table-tr">
                <td className="table-td-det">{x.time_ss}</td>
                {/* <td className="table-td">{x.object_id}</td> */}
                <td className="table-td">{x.class}</td>
                <td className="table-td">{parseFloat(x.distance).toFixed(2)}</td>
                <td className="table-td">{parseFloat(x.speed).toFixed(2)}</td>
                {/* <td className="table-td">{x.zone}</td> */}
            </tr>
            )}
            </tbody>
            </Table>
            <Pagination
                sizePerPage={itemsPerPage}
                currentPage={currentPage}
                totalSize={RLDdet.length}
                changeCurrentPage={paginate}
                theme="bootstrap"
            />
            </div>
        </div>
        ):(
            <div className="col-md-12 hide-from-printer">
            <Spinner animation="grow" size="sm" role="status" variant="warning" />
            <span className="text-dark">  Loading...</span>
            </div>
            )}
    </div>
)}

export default DetZone;